var map = {
	"./Dashboard.svg": "sutD",
	"./company.svg": "znPN",
	"./documentation.svg": "zUKd",
	"./edit.svg": "ql+d",
	"./example.svg": "OOLB",
	"./eye-open.svg": "no6o",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./group.svg": "hjGX",
	"./icon_addresslist_fil.svg": "VjRL",
	"./international.svg": "SBEl",
	"./language.svg": "+Dip",
	"./link.svg": "KgwQ",
	"./management.svg": "bZrc",
	"./member.svg": "/LrJ",
	"./nested.svg": "798r",
	"./news.svg": "zgXw",
	"./password.svg": "QjmH",
	"./peoples.svg": "TgHK",
	"./picture.svg": "3n9f",
	"./profile.svg": "+nPx",
	"./table.svg": "oSYw",
	"./tree.svg": "3eCm",
	"./user-line.svg": "X+cu",
	"./user.svg": "VdD3",
	"./userlist.svg": "kXp8"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 68